// services/otherSchedule.ts
import api from './api';
import { OtherSchedule, Customer } from '../types/otherSchedule';

export const otherScheduleService = {
  // その他スケジュール関連
  async getOtherSchedulesByDateRange(startDate: string, endDate: string) {
    const response = await api.get(`/other-schedule/range`, {
      params: { startDate, endDate }
    });
    
    // 明示的にその他予定タイプを設定
    if (response.data && response.data.schedules) {
      response.data.schedules = response.data.schedules.map((schedule: any) => ({
        ...schedule,
        type: 'other'
      }));
    }
    
    return response.data;
  },

  async getOtherScheduleById(id: number) {
    const response = await api.get(`/other-schedule/${id}`);
    return response.data;
  },

  async createOtherSchedule(scheduleData: OtherSchedule) {
    const response = await api.post(`/other-schedule/create`, {
      customerId: scheduleData.customerId,
      scheduleDate: scheduleData.scheduleDate,
      startTime: scheduleData.startTime,
      endTime: scheduleData.endTime,
      meetingTime: scheduleData.meetingTime,
      isAllDay: scheduleData.isAllDay,
      scheduleContent: scheduleData.scheduleContent,
      notes: scheduleData.notes,
      createdBy: localStorage.getItem('username') || 'system',
      memberData: scheduleData.memberData,
      vehicleData: scheduleData.vehicleData,
      teamType: scheduleData.teamType,
      requiredWorkers: scheduleData.requiredWorkers
    });
    return response.data;
  },

  async updateOtherSchedule(id: number, scheduleData: Partial<OtherSchedule>) {
    const response = await api.put(`/other-schedule/${id}`, {
      customerId: scheduleData.customerId,
      scheduleDate: scheduleData.scheduleDate,
      startTime: scheduleData.startTime,
      endTime: scheduleData.endTime,
      meetingTime: scheduleData.meetingTime,
      isAllDay: scheduleData.isAllDay,
      scheduleContent: scheduleData.scheduleContent,
      notes: scheduleData.notes,
      memberData: scheduleData.memberData,
      vehicleData: scheduleData.vehicleData,
      teamType: scheduleData.teamType,
      requiredWorkers: scheduleData.requiredWorkers
    });
    return response.data;
  },

  async deleteOtherSchedule(id: number) {
    const response = await api.delete(`/other-schedule/${id}`);
    return response.data;
  },
  
  // 顧客の一覧を取得
  async getCustomers() {
    const response = await api.get(`/customers/list`);
    return response.data.customers; // .customersを追加
  }
};